import React from 'react'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Header from './header'
import HeaderBox from '@/javascript/presentation/components/boxes/header-box'
import { LoadResourcePlaceList } from '@/javascript/domain/usecases'

type Props = {
  hasAddMemberPermission: boolean
  fetchResourcePlaces: LoadResourcePlaceList
}

const List: React.FC<Props> = ({ hasAddMemberPermission, fetchResourcePlaces }) => {
  return (
    <>
      <Box sx={{ bgcolor: 'background.header' }}>
        <HeaderBox>
          <Header hasAddMemberPermission={hasAddMemberPermission} fetchResourcePlaces={fetchResourcePlaces}/>
        </HeaderBox>
      </Box>
      <Divider />
    </>
  )
}

export default List
